<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="EP1"><span class="ePub-I">Omnia mutantur, nihil interit.</span></p>
<p class="EP">(Everything changes, nothing is lost.)</p>
<p class="EPC">—Ovid, <span class="ePub-I">Metamorphoses</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?6c54dfc2